<template>
  <div class="modal_window" @click="close" v-show="visible">
    <div class="modal_container">
      <div class="modal" @click.stop>
        <div class="head">
          <span>{{ title }}</span>
          <img @click="close" src="@/assets/imgs/playlist/delete.svg"/>
        </div>
        <div class="content">
          <input ref='input' v-model="value" @change="changeHandler" @keyup.enter="submit" />
        </div>
        <div class="footer">
          <button @click="submit" class="btn">{{buttonName ? buttonName : 'Добавить'}}</button>
          <button @click="close" class="btn">Закрыть</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StatefulModalMixin from '@/mixins/StatefulModal'

export default {
    name: 'InputModal',
    mixins: [StatefulModalMixin],
    data: () => ({
        value: "",
    }),
    props: {
        title: String,
        buttonName: String,
    },
    methods: {
        changeHandler(){
        this.$emit('update:modelValue', this.value)
      },
        submit() {
            this.$emit('submit', this.value, this.state);
            this.$emit('update:modelValue', this.value)
            this.close();
        },
    },
    watch: {
        visible: function(isOpen){
          if(isOpen){
            setTimeout(() => {this.$refs.input.focus(); }, 100); // NOTE: ugly workaround
            this.value = this.defaultValue;
          }
        },
    }
}
</script>
<style scoped>  
  .modal_container {
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.75);
    display: flex;
    align-items: center;
    justify-content: center;
    overflow-y: hidden;
  }
  .modal_container .modal {
    max-width: 480px;
    width: 100%;
    max-height: 90%;
    overflow: hidden;
    background: #EFEFEF;
    border: 1px solid #080808;
    box-sizing: border-box;
    box-shadow: 0 0 8px rgb(0 0 0 / 30%);
    z-index: 11;
    display: flex;
    flex-direction: column;
  }
  .modal .head {
    background: #555;
    color: #FFF;
    margin: 0;
    padding: 10px;
    font-size: 1.3em;
    font-weight: bold;
    display: flex;
    justify-content: space-between;
  }
  .head img {
    filter: invert(1);
    cursor: pointer;
  }
  .modal .footer {
    width: 100%;
    padding: 10px;
    text-align: right;
    border-top: 1px solid #CCC;
    background-color: #efefef;
  }
  .modal .content {
    width: 100%;
    padding: 0px;
  }
  .modal .content input {
    margin: 0;
    border: 1px solid #CCC;
    padding: 10px;
    font-size: 1.2em;
    display: block;
    width: 100%;
    box-sizing: border-box;
    outline: none;
  }
</style>
